export const setIndex = function (state, payload) {
  state.index = payload;
};
